import React from "react";
import { Modal } from "antd";
import { t } from "i18next";
import {
   Checkbox,
   InputText,
   NumberInput,
   SelectInput,
   Form,
   Button,
   Spin
} from "common/elements";
import {
   getOne,
   insertNewRecord,
   updateRecordById,
} from "services/payroll_item";

export default class FormModal extends React.PureComponent {
   state = {
      visible: false,
      id: null,
      submitting: false,
      loading: false
   };

   showModal = (id) => {
      if (id) {
         this.setState({
            loading: true,
            visible: true
         });

         getOne(id)
            .then((response) => {
               if (response) {
                  const formData = response.data;
                  this.props.form.setFieldsValue({
                     title: formData.title,
                     titleKH: formData.titleKH,
                     code: formData.code,
                     taxRate: formData.taxRate,
                     type: formData.type,
                     formular: formData.formular,
                     format: formData.format,
                     offeredBy: formData.offeredBy,
                     exportable: formData.exportable,
                     visibleInPayslip: formData.visibleInPayslip,
                     columnWidth: formData.columnWidth,
                     order: formData.order
                  });
               }
            })
            .catch(error => {
               if (error.response.status === 403) {
                  localStorage.removeItem("ACCESS_TOKEN");
                  this.props.navigate("/signin");
               }
            })
            .finally(() => {
               this.setState({
                  visible: true,
                  id,
                  loading: false,
               });
            });
      } else {
         this.setState({
            visible: true,
            id: null
         });
      }
   };

   handleCancel = () => {
      this.props.form.resetFields();
      this.setState({
         visible: false,
         submitting: false,
      });
   };

   onFinish = (values) => {
      this.setState({ submitting: true });
      if (this.state.id) {
         updateRecordById(this.state.id, values)
            .then(() => {
               this.setState({
                  visible: false,
               });
               this.props.form.resetFields();
               this.props.onSuccess();
            })
            .finally(() => {
               this.setState({ submitting: false });
            });
      } else {
         insertNewRecord(values)
            .then(() => {
               this.setState({
                  visible: false,
               });
               this.props.form.resetFields();
               this.props.onSuccess();
            })
            .finally(() => {
               this.setState({ submitting: false });
            });
      }
   };

   render() {
      const {
         visible,
         submitting,
         loading,
         id
      } = this.state;

      return visible ? (
         <Modal
            title={id ? t("text_edit_payroll_item") : t("text_new_payroll_item")}
            visible={visible}
            onCancel={this.handleCancel}
            style={{ top: 20 }}
         >
            <Spin spinning={loading}>
               <Form
                  form={this.props.form}
                  onFinish={this.onFinish}
                  layout="vertical"
                  key={id}
               >
                  <InputText
                     name="title"
                     label={t("text_name")}
                     placeholder={t("text_payroll_item_in_english")}
                     requiredMessage={t("text_please_input_payroll_item_in_english")}
                     isAutoSelect={true}
                  />
                  <InputText
                     name="titleKH"
                     label={t("text_name_Kh")}
                     isAutoSelect={true}
                     placeholder={t("text_payroll_item_in_khmer")}
                     requiredMessage={t("text_please_input_payroll_item_in_khmer")}
                  />
                  <InputText
                     name="code"
                     label={t("text_code")}
                     placeholder={t("text_by_default_it_auto_generate_from_name_in_English")}
                     isAutoSelect={true}
                  />
                  <SelectInput
                     name="type"
                     label={t("text_type")}
                     placeholder={t("text_select_type")}
                     valueKey="id"
                     required={true}
                     errorMessage={t("text_please_select_type")}
                     isAutoSelect={true}
                     dataSource={[
                        { id: 0, name: t("text_taxable_earning") },
                        { id: 1, name: t("text_non_taxable_earning") },
                        { id: 5, name: t("text_taxable_deduction") },
                        { id: 2, name: t("text_non_taxable_defuction") },
                        { id: 4, name: t("text_pension_fund") },
                        { id: 6, name: t("text_allowance") },
                        { id: 3, name: t("text_exclude_item") },

                     ]}
                  />
                  <NumberInput
                     name="taxRate"
                     label={t("text_tax_rate")}
                     placeholder={t("text_tax_rate")}
                     isAutoSelect={true}
                     min={0}
                  />
                  <SelectInput
                     name="offeredBy"
                     label={t("text_offered_by")}
                     placeholder={t("text_offered_by")}
                     valueKey="id"
                     dataSource={[
                        { id: "EMPLOYEE", name: t("text_employee") },
                        { id: "ORGANIZATION", name: t("text_government") }
                     ]}
                  />
                  <SelectInput
                     name="formular"
                     label={t("text_formular")}
                     placeholder={t("text_select_formular")}
                     valueKey="id"
                     required={true}
                     errorMessage={t("text_please_select_formular")}
                     isAutoSelect={true}
                     dataSource={[
                        { id: 0, name: t("text_earning") },
                        { id: 1, name: t("text_deduction") },
                        { id: 2, name: t("text_none") },
                     ]}
                  />
                  <SelectInput
                     name="format"
                     label={t("text_format")}
                     placeholder={t("text_select_format")}
                     valueKey="id"
                     required={true}
                     errorMessage={t("text_please_select_format")}
                     isAutoSelect={true}
                     dataSource={[
                        { id: "USD", name: "USD" },
                        { id: "KHR", name: "KHR" },
                        { id: "KHR-FIXED", name: "KHR - FIXED" },
                        { id: "PERCENTAGE", name: "Percentage" },
                        { id: "NONE", name: "None" },
                     ]}
                  />
                  <Form.Item name="exportable" valuePropName="checked">
                     <Checkbox>
                        {t("text_exportable")}
                     </Checkbox>
                  </Form.Item>

                  <Form.Item name="visibleInPayslip" valuePropName="checked">
                     <Checkbox>
                        Display In Payslip
                     </Checkbox>
                  </Form.Item>

                  <NumberInput
                     name="columnWidth"
                     label={t("text_column_width")}
                     placeholder={t("text_column_width_place_holder")}
                     isAutoSelect={true}
                  />

                  <NumberInput
                     name="order"
                     label={t("text_order")}
                     placeholder={t("text_order")}
                     isAutoSelect={true}
                     min={0}
                  />

                  <div className="ant-modal-footer2">
                     <Button
                        className="btn-cancel"
                        onClick={this.handleCancel}
                        disabled={submitting}
                     >
                        {t("text_cancel")}
                     </Button>
                     <Button
                        className="btn-save"
                        type="primary"
                        htmlType="submit"
                        loading={submitting}
                     >
                        {t("text_save")}
                     </Button>
                  </div>
               </Form>
            </Spin>
         </Modal>
      ) : (
         <div />
      );
   }
}
